module.exports = __webpack_public_path__ + "img/Stepping APA, 1984.0d8e9737.png";